import { render, staticRenderFns } from "./ProntuarioTriagem.vue?vue&type=template&id=d0e399e4&"
import script from "./ProntuarioTriagem.vue?vue&type=script&lang=js&"
export * from "./ProntuarioTriagem.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioTriagem.vue?vue&type=style&index=0&id=d0e399e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports